export class Pagination implements Pagination {
    public descending?: boolean = false;
    /**
     * 分页的当前页数,从1开始
     * @type {number}
     */
    public page = 1;
    public rowsNumber?: number = 0;
    public rowsPerPage = 0;
    public sortBy?: string = '';
    
    /**
     * 快速创建分页对象
     * @param page 当前页数,从1开始
     * @param size 每次分页要有多少个对象
     * @returns {Pagination}
     */
    public static of(page: number, size: number): Pagination {
        const pagination = new Pagination();
        pagination.page = page;
        pagination.rowsPerPage = size;
        return pagination;
    }
    
}
